import React from "react";
import { motion } from "framer-motion";
import { MaskedLines, FadeUp } from "@/components/Reveal";
import { staggerParent, fadeUp, viewportOnce } from "@/lib/anim";

const STEPS = [
    {
        n: "01",
        title: "Ci contatti",
        desc: "Ci scrivi su WhatsApp e valutiamo insieme il tuo immobile, i tuoi obiettivi e il potenziale di rendita.",
    },
    {
        n: "02",
        title: "Sopralluogo e analisi immobile",
        desc: "Veniamo a vedere la casa di persona: analizziamo spazi, dotazioni e posizione per stimare in modo realistico la resa.",
    },
    {
        n: "03",
        title: "Formalizzazione della collaborazione",
        desc: "Definiamo insieme condizioni e obiettivi e mettiamo nero su bianco l'accordo, in modo chiaro e trasparente.",
    },
    {
        n: "04",
        title: "Avviamento pratiche + Allestimento",
        desc: "Gestiamo CIR/CIN, SCIA e comunicazioni alla questura e curiamo styling, servizio fotografico e allestimento della casa.",
    },
    {
        n: "05",
        title: "Creazione annuncio sui portali",
        desc: "Pubblichiamo e ottimizziamo l'annuncio su Airbnb, Booking e altre piattaforme, con pricing dinamico per massimizzare le prenotazioni.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="come-funziona"
            className="relative scroll-mt-24 bg-[var(--fama-bg)] py-24 lg:py-32"
            data-testid="how-it-works-section"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-3xl">
                    <FadeUp>
                        <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-[var(--fama-gold)]">
                            Come funziona
                        </span>
                    </FadeUp>
                    <MaskedLines
                        as="h2"
                        lines={["Cinque passi", "verso zero pensieri."]}
                        className="mt-5 font-serif-display text-4xl leading-[1.02] tracking-[-0.01em] text-[var(--fama-ink)] sm:text-5xl lg:text-6xl"
                    />
                </div>

                <motion.div
                    variants={staggerParent(0.14)}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="relative mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6"
                >
                    {STEPS.map((s, i) => (
                        <motion.div
                            key={s.n}
                            variants={fadeUp}
                            data-testid={`step-${s.n}`}
                            className="relative"
                        >
                            <div className="flex items-center gap-4">
                                <span className="font-serif-display text-6xl leading-none text-[var(--fama-gold)]">
                                    {s.n}
                                </span>
                                {i < STEPS.length - 1 && (
                                    <span className="hidden h-px flex-1 bg-[var(--fama-border)] lg:block" />
                                )}
                            </div>
                            <h3 className="mt-6 font-serif-display text-2xl leading-tight text-[var(--fama-ink)]">
                                {s.title}
                            </h3>
                            <p className="mt-3 font-body text-sm leading-relaxed text-[var(--fama-ink-soft)]">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
